// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconInfoCardTextOnly: React.FC<{}> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="317"
            height="155"
            viewBox="0 0 317 155"
        >
            <defs>
                <path id="a" d="M0,0 L1366,0 L1366,3626 L0,3626 L0,0 Z" />
            </defs>
            <g fill="none" fillRule="evenodd" transform="translate(-16 -819)">
                <use xlinkHref="#a" fill="#FFF" />
                <g transform="translate(17 820)">
                    <path
                        fill="#FFF"
                        stroke="#B0AEAE"
                        d="M315.5,4 L315.5,149 C315.5,151.485281 313.485281,153.5 311,153.5 L4,153.5 C1.51471863,153.5 -0.5,151.485281 -0.5,149 L-0.5,4 C-0.5,1.68589197 1.25464599,-0.244648199 3.56580788,-0.478712149 L4.00000021,-0.499999755 L311,-0.5 C313.485281,-0.5 315.5,1.51471863 315.5,4 Z"
                    />
                    <g transform="translate(12 12)">
                        <text fill="#00214A" fontFamily="Adelle-Bold, Adelle" fontSize="14" fontWeight="bold">
                            <tspan x="0" y="125">
                                Call to Action Text
                            </tspan>
                        </text>
                        <text fill="#3B3B3B" fontFamily="Adelle-Regular, Adelle" fontSize="14">
                            <tspan x="0" y="43">
                                Lorem ipsum dolor sit amet, consectetur{" "}
                            </tspan>
                            <tspan x="0" y="65">
                                adipiscing elit. Fusce accumsan libero urna,{" "}
                            </tspan>
                            <tspan x="0" y="87">
                                non mollis sem semper nec.
                            </tspan>
                        </text>
                        <text fill="#0C0908" fontFamily="TVNordEF-BlackCon" fontSize="18">
                            <tspan x="0" y="16">
                                {"{This Is H5 Bucket Title}"}
                            </tspan>
                        </text>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconInfoCardTextOnly);
